<div
	class="content_alerts"
	*ngIf="showComponent"
	[ngClass]="{
		alerta_confirmacion: isSnackBar === false && (type === 'succes' || type === 'warn'),
		snackbar: isSnackBar,
		show: showSnackBar
	}"
>
	<div
		class="alert"
		[ngClass]="{
			alert_info: type === 'info',
			alert_aviso: type === 'warn',
			alert_exito: type === 'succes',
			alert_advertencia: type === 'warn-ligth',
			alert_error: type === 'error'
		}"
		[style.border]="getBorder()"
	>
		<span><img [src]="getPathImage()" alt="aviso" /></span>

		<div class="content_texts">
			<strong class="title" *ngIf="title">{{ title }} </strong>
			<div class="message" [innerHtml]="message | safe: 'html'"></div>
		</div>

		<div *ngIf="extraContent" [innerHtml]="extraContent"></div>

		<a *ngIf="showCloseButton" class="close_alert" (click)="clickClose()"></a>
	</div>
</div>
